/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineCog, HiOutlineFolder, HiOutlineTag } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { usePageContext } from "../../context/PageContext";
import { pushOnePage } from "../../lib/sysNavigation/SysNavigation";

type CategoryRow = { name: string };

const addRoute = "/page/add";
const editRoute = "/page/edit";

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { categories, fetchPages, page: pages } = usePageContext() as any;

  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!categories) fetchPages(1, 1000);
  }, [categories]);

  const rows = useMemo<CategoryRow[] | null>(() => {
    if (!Array.isArray(categories)) return null;
    const source = (categories as string[]).map((name) => ({ name }));
    const q = query.trim().toLowerCase();
    if (!q) return source;
    return source.filter((c) => c.name.toLowerCase().includes(q));
  }, [categories, query]);

  const columns: Column<CategoryRow>[] = [
    {
      header: "Category",
      cell: (row) => (
        <div className="flex items-center gap-3">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-brand/10 text-[10px] font-bold text-brand ring-1 ring-inset ring-brand/15">
            {row.name.slice(0, 2).toUpperCase()}
          </span>
          <div className="min-w-0">
            <p className="truncate font-medium text-gray-900">{row.name}</p>
            <p className="mt-0.5 inline-flex items-center gap-1 text-[11px] text-gray-500">
              <HiOutlineTag className="h-3 w-3" />
              Page category
            </p>
          </div>
        </div>
      ),
    },
  ];

  const rowActions = (row: CategoryRow): Action[] => [
    {
      label: "Manage",
      icon: <HiOutlineCog className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOnePage({ category: row.name, localPages: pages });
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<CategoryRow>
      title="Pages"
      subtitle="Categories and pages visible on the public site."
      icon={<HiOutlineFolder className="h-5 w-5" />}
      actions={[{ label: "Add page", variant: "primary", href: addRoute }]}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.name}
      rowActions={rowActions}
      search={{
        value: query,
        onChange: setQuery,
        placeholder: "Search categories…",
      }}
      empty="No page categories yet."
    />
  );
};

export default Overview;
